import React, { useState, useEffect } from 'react';
import { Main, Axios, usePaginacion, Paginacion } from '../Helpers/importacionesComunes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-regular-svg-icons';
import { faMapMarkerAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { hacerfocoEnPrimerInput } from '../Helpers/utilidades-globales';
import { Spinner, Typography } from '@material-tailwind/react';

export default function Busqueda({ finalizarSeleccion, objetoModificacion }) {

    const [provincias, setProvincias] = useState([]);
    const [buscando, setBuscando] = useState(false);
    const [huboError, setHuboError] = useState(false);
    const [textoBusqueda, setTextoBusqueda] = useState('');

    useEffect(() => {
        setBuscando(true);
        const buscarProvincias = async () => {
            try {
                const { data } = await Axios.get('/api/tablasgenerales/provincias');
                setProvincias(data);
                setBuscando(false);
                setTimeout(() => {
                    hacerfocoEnPrimerInput("texto-busqueda-prov");
                }, 200);
            } catch (err) {
                console.log(err.response?.data);
                setBuscando(false);
                setHuboError(true);
            }
        };

        buscarProvincias();
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
    }

    function limpiarFiltro() {
        setTextoBusqueda("");
        hacerfocoEnPrimerInput("texto-busqueda-prov");
    }

    const handleInputChange = (e) => {
        setTextoBusqueda(e.target.value);
    }

    function seleccionarProvincia(e, item) {
        finalizarSeleccion(item, objetoModificacion);
    }

    if (huboError) {
        return (
            <Main center>
                <div className='flex flex-col justify-center items-center mt-10 p-8'>
                    <Typography color="red" className="font-semibold">Se produjo un error al cargar los datos de provincias.</Typography>
                </div>
            </Main>
        );
    }

    if (buscando) {
        return (
            <Main center>
                <div className='flex flex-col justify-center items-center mt-10 p-8'>
                    <Spinner className="h-10 w-10 text-blue-500" />
                    <span className="mt-4 font-semibold text-gray-600">Buscando registros...</span>
                </div>
            </Main>
        );
    };

    return (
        <div className="flex flex-col w-full bg-white rounded-lg overflow-hidden pb-4">
            <Formulario
                handleSubmit={handleSubmit}
                textoBusqueda={textoBusqueda}
                handleInputChange={handleInputChange}
                limpiarFiltro={limpiarFiltro} />

            <Listado 
                provincias={provincias}
                textoBusqueda={textoBusqueda}
                seleccionarProvincia={seleccionarProvincia}
            />
        </div>
    )
}

function Listado({ provincias, textoBusqueda, seleccionarProvincia }) {

    const { configuracion, paginar, inicializar: inicializarPaginacion } = usePaginacion();
    const [provinciasEncontradas, setProvinciasEncontradas] = useState([]);

    useEffect(() => {
        const vector_aux = provincias.filter(
            item => item.nombre.toUpperCase().includes(textoBusqueda.toUpperCase())
        );
        setProvinciasEncontradas(vector_aux);
    }, [textoBusqueda, provincias]);

    useEffect(() => {
        inicializarPaginacion(null, provinciasEncontradas);
    }, [provinciasEncontradas]);

    return (
        <div className="flex flex-col w-full h-full">
            <div className="flex flex-col sm:flex-row justify-between items-center bg-gray-50 border-y border-gray-200 px-4 py-2 gap-2">
                <span className="text-xs font-semibold text-gray-500 bg-gray-200 px-2 py-1 rounded-md">
                    {provinciasEncontradas.length} registros ubicados
                </span>
                <div className="overflow-hidden">
                    <Paginacion configuracion={configuracion} paginar={paginar} />
                </div>
            </div>

            <div className="flex flex-col max-h-[400px] overflow-y-auto overflow-x-hidden relative mt-1">
                {provinciasEncontradas
                    .map((item, index) => { return { ...item, indice: index + 1 } })
                    .filter((item, index) => index >= configuracion.iIni && index <= configuracion.iFin)
                    .map((item, index) => (
                        <div
                            onClick={(e) => { seleccionarProvincia(e, item) }}
                            className="flex items-center gap-3 px-4 py-3 mx-2 my-1 border-b border-gray-100 hover:bg-blue-50 cursor-pointer transition-colors duration-150 group rounded-lg"
                            key={`prov-${item.id_provincia}`}
                        >
                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-500 group-hover:bg-blue-500 group-hover:text-white transition-colors shrink-0">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="text-sm" />
                            </div>
                            <span className="text-sm font-medium text-gray-700 group-hover:text-blue-900 truncate">
                                {item.nombre}
                            </span>
                        </div>
                    ))
                }
                
                {provinciasEncontradas.length === 0 && (
                    <div className="p-8 text-center text-gray-400 text-sm">
                        No se encontraron resultados para su búsqueda
                    </div>
                )}
            </div>
        </div>
    )
}

function Formulario({ handleSubmit, textoBusqueda, handleInputChange, limpiarFiltro }) {
    return (
        <form onSubmit={handleSubmit} className="px-4 py-4 bg-white mt-1">
            <div className="relative flex items-center w-full group">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400 group-focus-within:text-blue-500 transition-colors">
                    <FontAwesomeIcon icon={faSearch} />
                </div>

                <input
                    value={textoBusqueda}
                    onChange={handleInputChange}
                    type="text"
                    name="busqueda"
                    id="texto-busqueda-prov"
                    title="Ingrese la provincia o localidad"
                    autoComplete="off"
                    placeholder="Buscar provincia, partido o localidad..."
                    className="w-full pl-10 pr-10 py-2.5 text-sm border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-blue-100 focus:border-blue-400 focus:bg-white transition-all outline-none text-gray-700 placeholder-gray-400"
                />

                {textoBusqueda !== "" && (
                    <button
                        type="button"
                        onClick={limpiarFiltro}
                        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-red-500 transition-colors bg-transparent border-0 outline-none"
                        title="Limpiar búsqueda"
                    >
                        <FontAwesomeIcon icon={faWindowClose} className="text-lg" />
                    </button>
                )}
            </div>
        </form>
    )
}

